<script lang="ts" setup>
import { __ } from '@@/bits/intl'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from '@@/library/v4/components/OzContainedButton.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import OzPadletLogo, {
  OzPadletLogoColorScheme,
  OzPadletLogoSizePreset,
} from '@@/library/v4/components/OzPadletLogo.vue'
import SkipToContentLink from '@@/vuecomponents/SkipToContentLink.vue'

defineProps<{
  showUrl: string
  title: string
  description: string
}>()
</script>

<template>
  <div class="flex flex-col items-center justify-center h-full">
    <header :class="['fixed top-0', 'flex items-center justify-between ', 'box-border w-full', 'ps-5 pt-4']">
      <SkipToContentLink />

      <OzPadletLogo
        :size-preset="OzPadletLogoSizePreset.W48px"
        :color-scheme="OzPadletLogoColorScheme.Text300"
        :dark-mode="true"
      />
    </header>

    <main
      id="main-content"
      :class="[
        'flex flex-col items-center justify-center space-y-4',
        'w-[360px] box-border',
        'p-4 tablet-portrait:mb-6',
        'text-light-text-100',
      ]"
      tabindex="-1"
    >
      <OzIcon name="eye_slash" :size="24" />
      <div class="px-2 text-center">
        <h1 class="text-heading-3 font-semibold">{{ title }}</h1>
        <p class="text-body-small-posts mt-2">
          {{ description }}
        </p>
      </div>
      <OzContainedButton
        :href="showUrl"
        target="_blank"
        :color-scheme="OzContainedButtonColorScheme.Primary"
        :size-preset="OzContainedButtonSizePreset.H40px"
        :text="__('Open in new tab')"
      />
    </main>
  </div>
</template>

<style lang="postcss">
@import '@@/styles/4/kit';

html {
  font-size: 16px;
  background-color: #47118c;
}
</style>
